import React from 'react';
import { SvgIconProps } from '@mui/material';

export const ShareButtonIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.25039 11.285L16.404 7.25M16.3 18.9516L8.14624 14.9167M23.2001 5.33333C23.2001 7.45042 21.5697 9.16667 19.5584 9.16667C17.5472 9.16667 15.9168 7.45042 15.9168 5.33333C15.9168 3.21624 17.5472 1.5 19.5584 1.5C21.5697 1.5 23.2001 3.21624 23.2001 5.33333ZM8.63343 13C8.63343 15.1171 7.003 16.8333 4.99176 16.8333C2.98053 16.8333 1.3501 15.1171 1.3501 13C1.3501 10.8829 2.98053 9.16667 4.99176 9.16667C7.003 9.16667 8.63343 10.8829 8.63343 13ZM23.2001 20.6667C23.2001 22.7838 21.5697 24.5 19.5584 24.5C17.5472 24.5 15.9168 22.7838 15.9168 20.6667C15.9168 18.5496 17.5472 16.8333 19.5584 16.8333C21.5697 16.8333 23.2001 18.5496 23.2001 20.6667Z"
            stroke="currentColor"
            strokeWidth="2"
        />
    </svg>
);

export default ShareButtonIcon;
